<template>
  <div class="body">
    <div class="popup">
      <div class="t-c">
        <img src="@/assets/dzp/t_h.png" alt="">
      </div>
      <van-field
        v-model="iccid"
        name="mobile"
        label="号码："
        placeholder="请输入你要激活的号码"
        :rules="[{ required: true, message: '请输入你要激活的号码' }]"
      />
      <van-button
        class="bu_tn"
        round
        block
        type="info"
        native-type="submit"
        @click="onSubmit"
      >确认</van-button>
    </div>
  </div>
</template>
<script>
import { Dialog } from 'vant'
import { wxRequest } from '@/api/user.js'
import SeAutocomplete from '@/components/SeAutocomplete'
import Advertisement from '@/components/Advertisement'
export default {
  data() {
    return {
      code: '',
      iccid: ''
    }
  },
  created() {
    var source = 'wx18b33905435d410b'
    localStorage.setItem('appid', source)
    localStorage.setItem('isHeadquarterAppid', false)
    var appid = source || process.env.VUE_APP_APPID
    if (this.$route.query.iccid) {
      this.iccid = this.$route.query.iccid
    }
    console.log(appid)
    var redirectUrl = window.location.href
    var index = redirectUrl.indexOf('code')
    redirectUrl = encodeURIComponent(redirectUrl)
    if (index < 0) {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxb4bff16244869bed&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`
    } else {
      var search = window.location.search
      console.log('search', search)
      var startIndex = search.indexOf('code')
      var endIndex = search.indexOf('&', startIndex)
      var str = search.slice(startIndex, endIndex)
      var code = str.slice(str.indexOf('=') + 1)
      this.code = code
      // this.iccid = localStorage.getItem("recordLoginText");
      if (this.$route.query.iccid) {
        this.iccid = this.$route.query.iccid
      } else {
        this.iccid = localStorage.getItem('recordLoginText')
      }

      // 自动登录
      // if(this.iccid){
      //     this.userQuerySIM();
      // }
    }
    this.$store.commit('setIsHeadquarterAppid', 'true')
    localStorage.setItem('isHeadquarterAppid', true)
  },
  methods: {
    onSubmit() {
      const recordLoginText = this.iccid
      const data = {
        requestId: this.iccid,
        code: '1',
        isCode: 1
      }
      wxRequest('sim/bind', data, 'get').then((res) => {
        if (res.data.code == 200) {
          const record = res.data.data
          const iccid = record.iccid
          localStorage.setItem('isCode', true)
          localStorage.setItem('mobile', record.mobile)
          localStorage.setItem('supplierTypeName', record.supplierTypeName)
          localStorage.setItem('wxHeadImg', record.wxHeadImg)
          localStorage.setItem('wxNickName', record.wxNickName)
          localStorage.setItem('recordLoginText', recordLoginText)
          localStorage.setItem('supplierName', record.supplierName)
          localStorage.setItem('intoNo', record.intoNo)
          localStorage.setItem('iccid', record.iccid)
          localStorage.setItem('openId', record.openId)
          localStorage.setItem('virtualNo', record.virtualNo)
          localStorage.setItem('tuiPrice', record.tuiPrice) // 赠送金余额
          localStorage.setItem('firstLogin', 1)
          localStorage.setItem('basePkgGroup', record.basePkgGroup)
          this.$store.state.recordLoginText = recordLoginText
          this.$store.state.supplierCode = res.data.data.supplierCode
          this.$store.state.iccid = iccid
          this.$store.commit('setIccid', iccid)
          localStorage.setItem('newHome', 0)
          this.$store.state.newHome = 0

          this.$store.state.intoNo = record.intoNo
          sessionStorage.setItem('intoNo', record.intoNo)
          // 未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
          const cardType = record.supplierTypeCode
          const _data = {
            requestId: iccid,
            code: this.code
          }
          if (
            record.supplierCode == '1574603917105295360' &&
            record.cardState == 11
          ) {
            // 深圳联通做特殊限制
            Dialog.confirm({
              title: '换卡提示',
              message:
                '由于运营商管控，当前卡已暂停激活使用。请点击 确定 将为你更换网速更快的移动卡。感谢你的理解和支持！'
            })
              .then(() => {
                window.location.href = 'http://webchat.szxxtx.com/#/user/chgCardQuery'
              })
              .catch(() => {})
          } else {
            wxRequest('sim/bindIccid/appid', _data, 'get').then((res) => {
              if (res.data.data == true) {
                wxRequest('sim/is/have/price', { iccid: iccid }, 'get').then(
                  (res) => {
                    if (res.data.code == 200) {
                      this.$router.replace('/user/home')
                    } else {
                      if (
                        record.basePkgGroup == '1549295580465852416' ||
                        record.basePkgGroup == '1568163178611732480'
                      ) {
                        // 悟空卡
                        this.$router.replace('/user/simOpenWu')
                      } else if (
                        record.basePkgGroup == '1587749406130565120'
                      ) {
                        // 悟空卡Puls  105G
                        this.$router.replace('/user/simOpenWup')
                      } else if (record.basePkgGroup == '1549295498467209216') {
                        // 乐享卡
                        this.$router.replace('/user/simOpenLe')
                      } else if (
                        record.basePkgGroup == '1562613197939142656' ||
                        record.basePkgGroup == '1565598068475162624'
                      ) {
                        // 乐信卡 80元得240
                        this.$router.replace('/user/simOpenLex')
                      } else if (
                        record.basePkgGroup == '1574325852529750016' ||
                        record.basePkgGroup == '1574325802546229248'
                      ) {
                        // 悟净卡 开户预存 送赠送金
                        this.$router.replace('/user/cardOpens')
                      } else if (
                        record.basePkgGroup == '1579392078893281280' ||
                        record.basePkgGroup == '1579369236420096000' ||
                        record.basePkgGroup == '1579369201724813312'
                      ) {
                        // 冰星系列 开户预存+赠送金
                        this.$router.replace('/user/rechargePrice')
                        // 畅享卡系列 30*3+20*9优惠券  9.9元套餐
                      } else if (record.basePkgGroup == '1588080292403343360') {
                        this.$router.replace('/user/simOpenCxk')
                      }
                      // 畅享卡系列 30*2+20*10优惠券  9.9元套餐
                      else if (record.basePkgGroup == '1595609837910093824') {
                        this.$router.replace('/user/simOpenXy')
                      }
                      // 畅享卡系列 30*2+20*10优惠券  9.9元套餐
                      else if (record.basePkgGroup == '1595609014362697728') {
                        this.$router.replace('/user/simOpenYx')
                      } else if (record.basePkgGroup == '1597081108845948928') {
                        this.$router.replace('/user/simOpenXy8')
                      } else if (record.basePkgGroup == '1620242289261539328') {
                        this.$router.replace('/user/simOpenTn')
                      } else if (record.basePkgGroup == '1630400735126482944') {
                        this.$router.replace('/user/simOpenTnPNew')
                      } else if (record.basePkgGroup === '1639175906637377536') {
                        this.$router.replace('/user/simOpenXc')
                      }else if (record.basePkgGroup === '1656908136637788160') {
                        this.$router.replace('/newUser/simOpenTnPUp')
                      } else if (record.basePkgGroup === '1643557236171075584') {
                        this.$router.replace('/user/simOpenXcp')
                      }else if (record.basePkgGroup === '1647873729625059328') {
                        this.$router.replace('/user/simOpenTnVip')
                    }
                      // else if(record.isBindPhone!=1){
                      //   //新页面 要跳转绑定手机号页面。此页面暂时注释
                      // }
                      else {
                        this.$router.replace('/user/home') // 其它卡
                      }
                    }
                  }
                )
              } else {
                Dialog.alert({
                  title: '提示',
                  message: '授权失败 请重新扫码登录！'
                })
              }
            })
          }
        } else {
          Dialog.alert({ title: '提示', message: res.data.message })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.body {
  background: url("../../assets/dzp/659841b5.png") no-repeat center;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: relative;
  .popup {
    background: linear-gradient(0deg, #ffe1b1, #fff);
    box-sizing: border-box;
    padding: 25px 0;
    width: 325px;
    position: fixed;
    left: 0;
    right: 0;
    margin: auto;
    top: 25%;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    box-shadow: 0 6px 6px 0 rgb(219 0 0 / 75%);
    .t-c {
      height: 60px;
      text-align: center;
      img {
        height: 100%;
      }
    }
    .van-cell {
      height: 50px;
      width: 275px;
      border-radius: 17px;
      border: 2px solid #000;
      padding-left: 10px;
      background: none;
      margin: auto;
      margin-top: 20px;
      ::v-deep .van-cell__title {
        width: 50px;
      }
    }
    .bu_tn {
      height: 50px;
      line-height: 50px;
      text-align: center;
      width: 275px;
      color: #fff;
      background: #f43604;
      border-radius: 17px;
      margin: auto;
      margin-top: 20px;
      border: 1px solid #f43604;
    }
  }
}
</style>
